<template>
	<div :class="classes">
		<div v-if="!hideError && getNotificationString(notificationList)" id="errorContainer" class="alert alert-danger text-center" role="alert">
			<div class="error-section">
				<svgIcon iconHolderClass="icon-warning" iconId="icon-warning"/>
				<div v-html="getNotificationString(notificationList)"></div>
			</div>
			<slot/>
		</div>

		<transition appear name="fade" mode="out-in">
			<div v-if="$store.state.loading" class="page-spinner-wrapper main-spinner">
				<span class="spinner-circle"></span>
			</div>
			<router-view v-else class="body" name="body"></router-view>
		</transition>

		<dialogs-wrapper transition-name="fade"></dialogs-wrapper>
		<globalFooter v-if="(isLauncher && !checkSettingPageIn) || isSteamConnector || (isToy && region === 'global')">
		</globalFooter>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import globalFooter from './components/layout/global-footer';

export default {
	name: 'app',
	components: {
		globalFooter,
		svgIcon,
	},
	metaInfo() {
		return {
			title: this.$t('account.title'),
			meta: [
				{ name: 'description', content: this.$t('account.meta-desc') },
				{ name: 'keywords', content: this.$t('account.meta-keyword') },
				{ property: 'og:site_name', content: this.$t('account.title') },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'http://www.nexon.com/' },
				{ property: 'og:title', content: this.$t('account.title') },
				{ property: 'og:description', content: this.$t('account.meta-desc') },
				{
					property: 'og:image',
					content: 'https://web.nxfs.nexon.com/nexon-logo.png',
				},
				{ itemprop: 'name', content: this.$t('account.meta-title') },
				{ itemprop: 'description', content: this.$t('account.meta-desc') },
				{
					itemprop: 'image',
					content: 'https://web.nxfs.nexon.com/nexon-logo.png',
				},
				{
					'http-equiv': 'Content-Security-Policy',
					content: `default-src *.nexon.com *.nexon.io *.nexon.net *.google-analytics.com 'self';
						connect-src *.nexon.com *.nexon.net *.nexon.io *.serving-sys.com 'self';
						script-src *.nexon.com *.nexon.net *.google-analytics.com *.googletagmanager.com *.google.com *.facebook.net *.gstatic.com *.iesnare.com *.googleadservices.com *.doubleclick.net https://sentry.d.nexon.io *.serving-sys.com  https://gleam.io 'unsafe-eval' 'unsafe-inline' 'self';
						style-src *.nexon.com *.google.com *.googleapis.com 'unsafe-inline';
						img-src *.nexon.com *.google.com *.google-analytics.com https://www.googletagmanager.com *.gstatic.com *.doubleclick.net 'self' data:;
						font-src *.nexon.com *.google.com *.facebook.com 'self';
						frame-src *.nexon.com *.nexon.net *.google.com *.facebook.com`,
				},
			],
		};
	},
	data() {
		return {
			notificationList: [],
		};
	},
	computed: {
		classes() {
			return [this.channel, this.region, this.language];
		},
		maintenance() {
			return this.$store.state.configurations.maintenance;
		},
		isLauncher() {
			return navigator.userAgent.indexOf('NexonLauncher') > 0;
		},
		isSteamConnector() {
			return navigator.userAgent.indexOf('steam-connector') > 0;
		},
		isToy() {
			return this.$store.state.appType === 'toy';
		},
		productClass() {
			const prodId = this.$cookie.get('ProdId');
			return prodId ? `product-${prodId}` : false;
		},
		regionDataLayer() {
			const region = this.region;
			return region === 'global' ? 'west' : region;
		},
		language() {
			return this.$i18n.locale;
		},
		channel() {
			if (this.isLauncher) return 'launcher';
			if (this.isSteamConnector) return 'steam';
			if (this.isToy) return 'toy';
			return 'web';
		},
		hideError() {
			const result = this.notificationList.find((field) => field.Name === 'Account');
			return !result;
		},
		checkSettingPageIn() {
			if (this.$store.state.settings === null) {
				return false;
			}
			return true;
		},
	},
	methods: {
		maintenanceModeRedirect() {
			if (this.maintenance) {
				this.$router.push({ name: 'maintenance' });
			}
		},
		productIdClass() {
			const account = document.getElementById('account');
			account.classList.add(this.productClass);
		},
		storeDirectReturn() {
			if (this.$route.query.direct_return) {
				this.$store.commit('setDirectReturn', this.$route.query.direct_return);
			}
		},
		storeChannel() {
			if (this.channel !== 'web') {
				const account = document.getElementById('account');
				account.classList.add('launcher');
			}
			this.$store.commit('setChannel', this.channel);
		},
		getNotificationString(data) {
			if (!data) return '';
			const notification = data.find((field) => field.Name === 'Account');
			return notification.Message[this.$i18n.locale || this.$i18n.fallbackLocale];
		},
	},
	created() {
		this.productIdClass();
		this.maintenanceModeRedirect();
		this.storeDirectReturn();
		this.storeChannel();
		Promise.all([this.$notificationAPI.getNotificationList()]).then((d) => {
			this.notificationList = d[0];
		});
	},
	mounted() {
		window.version = `Current Version => ${VERSION}`;
	},
	updated() {
		dataLayer.push({
			channel: this.channel,
			region: this.regionDataLayer,
			language: this.language,
		});
	},
};
</script>

<style lang="less">
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
@import './less/global';
@import './less/responsive';

#errorContainer {
	margin-bottom: 1px;
}
.error-section {
	display: flex;
	justify-content: center;
	p {
		margin-bottom: 0px;
		padding-top: 2px;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue